import { api } from "@/lib/api";

import type {
  AddStockOpnameItemsReq,
  CancelStockOpnameReq,
  CompleteStockOpnameReq,
  CreateStockOpnameReq,
  GetStockOpnameListReq,
  StockOpname,
  StockOpnameListRes,
  UpdateStockOpnameReq,
} from "@artisancode/api-types";

export const stockOpnameService = {
  list: (params?: GetStockOpnameListReq) =>
    api.get<StockOpnameListRes>(
      "/stock-opnames",
      params as unknown as Record<
        string,
        string | number | boolean | undefined
      >,
    ),

  detail: (id: string, params?: { workspace_id?: string }) =>
    api.get<StockOpname>(
      `/stock-opnames/${id}`,
      params as Record<string, string | number | boolean | undefined>,
    ),

  create: (body: CreateStockOpnameReq, idempotencyKey?: string) =>
    api.post<StockOpname>(
      "/stock-opnames",
      body,
      idempotencyKey ? { "Idempotency-Key": idempotencyKey } : undefined,
    ),

  update: (id: string, body: UpdateStockOpnameReq) =>
    api.put<StockOpname>(`/stock-opnames/${id}`, body),

  addItems: (id: string, body: AddStockOpnameItemsReq) =>
    api.post<StockOpname>(`/stock-opnames/${id}/items`, body),

  removeItem: (id: string, lineId: string) =>
    api.del<StockOpname>(`/stock-opnames/${id}/items/${lineId}`),

  complete: (id: string, body?: CompleteStockOpnameReq) =>
    api.post<StockOpname>(`/stock-opnames/${id}/complete`, body ?? {}),

  cancel: (id: string, body: CancelStockOpnameReq) =>
    api.post<StockOpname>(`/stock-opnames/${id}/cancel`, body),
};
